module.exports = __webpack_public_path__ + "img/new_inbox_icon.dc45e19.png";